module.exports = __webpack_public_path__ + "img/vkreklama-logo.655b1012.svg";